module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prizeDetail"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("\n    活动管理 > 奖品管理 > 查看详情\n    "), (_vm.prize.online == 0) ? _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.importPrize
    }
  }, [_vm._v("移除并导出未发放奖品数据")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title imgSpan"
  }, [_vm._v("奖品图标：")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.prize.logoUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("奖品名称：")]), _vm._v(_vm._s(_vm.prize.prizeName) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("第三方奖励ID：")]), _vm._v(_vm._s(_vm.prize.defineText1) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("发放时间：")]), _vm._v(_vm._s(_vm.prize.deployStartTime) + " 至 " + _vm._s(_vm.prize.deployEndTime) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("奖品类型：")]), _vm._v(_vm._s(_vm.prize.prizeType) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel",
    staticStyle: {
      "height": "120px"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("奖励弹窗：")]), _vm._v(_vm._s(_vm.prize.windowType) + "\n      "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.prize.windowUrl),
      expression: "prize.windowUrl"
    }]
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-left": "150px"
    },
    attrs: {
      "src": _vm.prize.windowUrl,
      "alt": ""
    }
  })])]), _vm._v(" "), (_vm.prize.windowType == '自定义图片') ? _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("点击事件:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.prize.windowClickType))])]) : _vm._e(), _vm._v(" "), (_vm.prize.windowType == '自定义图片') ? _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("点击事件url:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.prize.windowClickUrl))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("奖励里程：")]), _vm._v(_vm._s(_vm.prize.prizeDisType) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("兑奖URL：")]), _vm._v(_vm._s(_vm.prize.prizeUrl || "同活动详情处URL") + "\n    ")]), _vm._v(" "), (_vm.prize.adExposingCodes) ? _c('div', {
    staticClass: "panel ad"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("广告曝光代码：")]), _vm._v(" "), _c('div', {
    staticClass: "adCode"
  }, [_vm._v("\n        " + _vm._s(_vm.prize.adExposingCodes) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.prize.redeemStartTime) ? _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("兑奖有效期：")]), _vm._v(_vm._s(_vm.prize.redeemStartTime) + " 至 " + _vm._s(_vm.prize.redeemEndTime) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.prize.redeemText) ? _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("兑换码文字说明：")]), _vm._v(_vm._s(_vm.prize.redeemText) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.prize.defineText2) ? _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("自定义文案：")]), _vm._v(" " + _vm._s(_vm.prize.defineText2) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("奖品详细数据：")]), _vm._v("  " + _vm._s(_vm.prize.prizeFromType) + " " + _vm._s(_vm.prize.prizeNum) + "个\n       " + _vm._s(_vm.prize.prizeFromType == '总共' ? '（所有参与学校均可领取）' : "") + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6efc22a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/activity/prizeDetail.vue
// module id = 1066
// module chunks = 0